import axios from 'axios';

import type {
	LocationRequestBody,
	LocationsResponse,
} from 'src/interfaces/Location';

const USA_LOCATION_CODE = 227;
const STATE_TYPE = '2';

const requestBody: LocationRequestBody = {
	tjIds: [USA_LOCATION_CODE],
	type: STATE_TYPE,
};

export const fetchLocationsUri = '/api/gtdcm/v1/tj/locations';

export async function fetchLocations() {
	const response = await axios.post<LocationsResponse>(
		fetchLocationsUri,
		requestBody
	);

	return response.data.data;
}
